export default [
  {
    path: "/others/profile",
    name: "others/profile",
    component: () => import("@/views/menu/profile/Profile.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/others/profile/edit-profile",
    name: "others/profile/edit-profile",
    component: () => import("@/views/menu/profile/EditProfile.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/others/my-product",
    name: "others/my-product",
    component: () => import("@/views/menu/profile/MyProduct.vue"),
    meta: {
      pageTitle: "Produk Saya",
      requireAuth: true,
      breadcrumb: [
        {
          text: "Produk Saya",
          active: true,
        },
      ],
    },
  },
  {
    path: "/cooming-soon",
    name: "cooming-soon",
    component: () =>
      import("@/views/menu/others/cooming-soon/cooming-soon.vue"),
    meta: {
      pageTitle: "",
      requireAuth: true,
    },
  },
];
